import { h, Component } from 'preact';
import { Router } from 'preact-router';
import style from './style.css';
import Sites from '../../routes/sites';
import Site from '../../routes/site';
import AddDevice from '../../routes/add-device';
import Account from '../../routes/account';
import Subscribe from '../../routes/subscribe';
import Login from '../../routes/login';
import Reports from '../../routes/reports';
import Settings from '../../routes/settings';
import GlobalConfig from '../../routes/global-config';
import Keg from '../../routes/keg';
import UntappdCb from '../../routes/untappd-cb';
import SquareCb from '../../routes/square-callback';
import LightspeedCb from '../../routes/lightspeed-callback';
import PosMapping from '../../routes/pos-mapping';
import GetApp from '../../routes/get-app';
import ErrorBoundary from '../error-boundary';

export default class Content extends Component {
    /** Gets fired when the route changes.
	 *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
	 *	@param {string} event.url	The newly routed URL
	 */
    handleRoute = e => {
        this.currentUrl = e.url;
    };

    render() {
        let self = this;

        return (
            <div className={style.content}>
                <ErrorBoundary>
                    <Router onChange={self.handleRoute}>
                        <Login app={self.props.app} path="/" />
                        <Sites app={self.props.app} path="/sites" />
                        <Site app={self.props.app} path="/sites/:name" />
                        <AddDevice app={self.props.app} path="/add-device" />
                        <Reports app={self.props.app} path="/reports" />
                        <Account app={self.props.app} path="/account" />
                        <Subscribe app={self.props.app} path="/subscribe" />
                        <Settings app={self.props.app} path="/config/:name/:id/:port" />
                        <GlobalConfig app={self.props.app} path="/global-config/:name" />
                        <Keg app={self.props.app} path="/sites/:name/:id/:port" />
                        <UntappdCb app={self.props.app} path="/untappd-callback" />
                        <SquareCb app={self.props.app} path="/square-callback" />
                        <LightspeedCb app={self.props.app} path="/lightspeed-callback" />
                        <PosMapping app={self.props.app} path="/pos/:name" />
                        <GetApp app={self.props.app} path="/app" />
                        <GetApp app={self.props.app} path="/app/:rest*" />
                    </Router>
                </ErrorBoundary>
            </div>
        );
    }
}
